export default "__VITE_PUBLIC_ASSET__f667bbd6__"